import { FileItemProps, FileMineType, FolderItemProps } from "apis";
import { lazy, RefObject } from "react";

export type LibraryViewMode = "grid" | "list";
export const PageAdminLibrary = lazy(() => import("./Container"));


export type ContextMenuItem = { item: FolderItemProps; type: "folder"; } | { item: FileItemProps; type: "file"; } | undefined;
export type ContextMenuData = { x: number; y: number; item: ContextMenuItem } | null;
export type OnContextMenuProps = (e: React.MouseEvent, ref: RefObject<HTMLUListElement | null>, item?: ContextMenuItem) => void;
export type SelectedItemType = { item: FolderItemProps; type: "folder"; } | { item: FileItemProps; type: "file"; }

export interface FormFolderValuesProps extends FolderItemProps { }
export interface FormFileValuesProps extends FileItemProps { }


const mimeMap: Record<FileMineType, string[]> = {
    image: ["image/*"],
    word: [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    excel: [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    pdf: ["application/pdf"],
    zip: ["application/zip", "application/x-zip-compressed"],
    video: ["video/*"],
    audio: ["audio/*"],
    all: ["*/*"]
};

export function getAcceptFromFileMineType(types?: FileMineType[]) {
    if (!types || types.length === 0) return undefined; // không truyền -> tất cả file
    return types.flatMap(type => mimeMap[type]).join(",");
}